import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import hydrateThreads from '@/redux/actions/pieveActions/hydrateThreads.js';
import { listCompanyThreads } from '@/redux/requests/threadsRequests.js';
import { routeThreadId } from '@/redux/selectors/pieveSelectors/routeSelectors.js';
import { activeCompanyId } from '@/redux/selectors/userSelectors.js';

/**
 * Loads the assistant's conversations for the active organization: the person's own list, the
 * conversations shared with the organization, and the events of the open conversation, which also
 * reattaches its live run stream when a run is in progress.
 */
const AssistantThreadsHandler = () => {
  const dispatch = useDispatch();
  const companyId = useSelector(activeCompanyId);
  const threadId = useSelector(routeThreadId);

  useEffect(() => {
    if (!companyId) {
      return;
    }
    listCompanyThreads();
  }, [companyId]);

  useEffect(() => {
    if (!companyId) {
      return;
    }
    dispatch(threadId ? hydrateThreads({ threadIdsForEvents: [threadId] }) : hydrateThreads({ skipEvents: true }));
  }, [dispatch, companyId, threadId]);

  return null;
};

export default AssistantThreadsHandler;
